import { render, staticRenderFns } from "./PointChange.vue?vue&type=template&id=181b501b&scoped=true"
import script from "./PointChange.vue?vue&type=script&lang=js"
export * from "./PointChange.vue?vue&type=script&lang=js"
import style0 from "./PointChange.vue?vue&type=style&index=0&id=181b501b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b501b",
  null
  
)

export default component.exports